  import Vue from 'vue'
import Vuex from 'vuex'
import {PrivilegesCollection,usersCollection} from '@/FirebaseConfig'
import {cleanObject, secondsToFullTimestamp} from '@/Helper.js'  
import {mainAuth} from '@/FirebaseConfig'

Vue.use(Vuex)
export default {
    namespaced:true,
    
      state: {
        checkbox: false,
        radioGroup: 1,
        data:{
          name:'',
          routerName:'',
          icon:'',
          order:'',
          type:false,
          createdAt:'',
        },
        dialog: false,
        record:{},
        allRecord: {},
        selectedKey: ''
      },
      mutations: {
        clean(state,key){
          Vue.delete(state.PrivilegesRecord,key)
        },
        getRoutes(state, item) {
          Vue.set( state.record, item.id, {...item.data(), createdAt: secondsToFullTimestamp(item.data().createdAt)} )
        },
        getAllRoutes(state, item) {
          Vue.set( state.allRecord, item.id, {...item.data(), createdAt: secondsToFullTimestamp(item.data().createdAt)} )
        },
      
      },
      actions: {
       
        getAll: context=>{
          context.state.record = {}
          PrivilegesCollection.get().then(data=>data.docs.map(async item=>{
            if( await compare(item)) context.commit( 'getRoutes', item  )
            context.commit( 'getAllRoutes', item)
          }))
        },
        add:context=>{
          if(context.state.selectedKey==''){
            PrivilegesCollection.add({...context.state.data, createdAt:new Date}).then(()=>{
              context.commit('Helpers/launchSnackbar', 'Se ha registrado un nuevo privilegio correctamente', { root: true })
              cleanObject(context.state.data)
              context.state.dialog = false
            })
          }else{
            PrivilegesCollection.doc(context.state.selectedKey).update(context.state.data).then(()=>{
              context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })
              cleanObject(context.state.data)
              context.state.dialog = false
            })
          }
        },
        clean:(context, key)=>{
          PrivilegesCollection.doc(key).delete().then(()=>{
            context.commit('Helpers/launchSnackbar', ' Ha sido eliminado', { root: true })            
            context.commit('clean',key)})
        },
        get:(context, key)=>{
          
          PrivilegesCollection.doc(key).get().then(doc=>{
            context.state.data = doc.data()
            context.state.selectedKey = key
            context.state.dialog=true
          })
        },
        clearForm:(context)=>{
          context.state.dialog = false
          context.state.selectedKey = ''
          context.state.data = {
            name: '',
            createdAt: '',
            type:false,

          }
        },
      },
      getters: {
        record: state => Object.keys(state.record).map(item=> ({...state.record[item], key: item})),
        recordMain: state =>Object.keys(state.record).map(item => ({...state.record[item], key: item })).filter(item => item.type==true&&!item.contable).sort((a,b) =>a.order-b.order),
        recordSetting: state =>Object.keys(state.record).map(item => ({...state.record[item], key: item })).filter(item => item.type==false&&!item.contable).sort((a,b) =>a.order-b.order),
        recordContable: state =>Object.keys(state.record).map(item => ({...state.record[item], key: item })).filter(item => item.contable==true).sort((a,b) =>a.order-b.order),
      },
}
const compare = async (item) => {
  
  if(!mainAuth.currentUser) return 
 
  const currentUserEmail = mainAuth.currentUser.email

  const lookingForUser = await usersCollection.where('email', '==', currentUserEmail).get()
  
  if(lookingForUser.empty) return console.log('Usuario no tiene registrado privilegios')
  const userPrivilegesList = lookingForUser.docs[0].data().privileges

  return (userPrivilegesList.indexOf(item.data().routerName)>-1 ) ? true : false
    
}